import {
	createAsyncThunk,
	createEntityAdapter,
	createSlice,
} from "@reduxjs/toolkit";
import subscriptionService from "services/subscriptionService";
import { hideLoader, showLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";

export const fetchSubscriptions = createAsyncThunk(
	"vino/subscriptions/fetchList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			const subscriptions = await subscriptionService.getSubscriptions();
			return subscriptions;
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting subscriptions",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

export const fetchWineClubSubscriptions = createAsyncThunk(
	"vino/subscriptions/fetchWineClubList",
	async (_, { dispatch }) => {
		try {
			dispatch(showLoader());
			const subscriptions = await subscriptionService.getWineClubSubscriptions();
			return subscriptions;
		} catch (e) {
			console.error(e);
			dispatch(
				showMessage({
					message: "Error occurred while getting subscriptions",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const subscriptionAdapter = createEntityAdapter({});

export const {
	selectAll: selectSubscriptions,
} = subscriptionAdapter.getSelectors((state) => state.vino.subscriptions);

const subscriptionsSlice = createSlice({
	name: "vino/subscriptions",
	initialState: subscriptionAdapter.getInitialState(),
	reducers: {
		resetSubscriptionState: () => {
			return subscriptionAdapter.getInitialState();
		},
	},
	extraReducers: {
		[fetchSubscriptions.fulfilled]: subscriptionAdapter.setAll,
		[fetchWineClubSubscriptions.fulfilled]: subscriptionAdapter.setAll,
	},
});

export const { resetSubscriptionState } = subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
